import { Navigate, createBrowserRouter } from "react-router-dom";
import { storeRoutes } from "features/searchStore/routes";
import MainLayout from "components/Layout";
import { homeRoutes } from "features/homepage/routes";

const appRouter = createBrowserRouter([
  {
    path: "/",
    Component: MainLayout,
    children: [
      { index: true, element: <Navigate to="/home" /> },
      ...homeRoutes(),
      ...storeRoutes(),
    ],
  },
]);

export default appRouter;
